import { render, staticRenderFns } from "./EditCountryModal.vue?vue&type=template&id=27236a68"
import script from "./EditCountryModal.vue?vue&type=script&lang=js"
export * from "./EditCountryModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports